import { DescribableEnumeration } from '@bp/shared/models/core';

export class BridgerPspLegalEntityType extends DescribableEnumeration {

	static soleProprietorship = new BridgerPspLegalEntityType();

}
